// @ts-nocheck
const $ = document.querySelector.bind(document);
const setElement = (tag, selector, props) => {
    const { document } = window;
    let element = $(selector);
    const shouldInsert = !element;
    element || (element = document.createElement(tag));
    for (const k in props) {
        element.setAttribute(k, props[k]);
    }
    if (shouldInsert) {
        const head = document.head || $('head');
        head && head.appendChild(element);
    }
};
export default class Aplus {
    constructor() {
        this.load();
    }
    load() {
        if (!$('meta[name="aplus-core"]')) {
            this.loadAplusMeta();
        }
        if (!$('script[src*="/mlog/aplus_v2.js"]')) {
            // 插入aplus脚本
            this.loadAplusScript();
        }
        ;
    }
    loadAplusMeta() {
        setElement('meta', 'meta[name="aplus-core"]', {
            name: 'aplus-core',
            content: 'aplus.js'
        });
    }
    loadAplusScript() {
        setElement('script', 'script[id="tb-beacon-aplus"]', {
            id: 'tb-beacon-aplus',
            async: '',
            exparams: 'userid=&aplus&sidx=aplusSidex&ckx=aplusCkx',
            src: '//g.alicdn.com/alilog/mlog/aplus_v2.js',
            crossorigin: 'anonymous'
        });
    }
}
